import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";

import "react-tabs/style/react-tabs.css";
import TablaDeudasEjidos from "./tablaDeudaEjidos";
import TablaHistoricosEjidos from "./tabaHistoricoEjidos";
import moment from "moment";
import { CatalagoInmo2 } from "../../../catalogos/catalogoRentasInm";
import axios from "axios";
import { Dimmer } from "../../spinner";
//UI
import { Input, Radio, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, InfoButton, SuccessButton } from "../../../ui/buttons/Button";

export const RegistroContribuyenteEjido = (props) => {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const btnCancela = useRef();
  const btnCargar = useRef();
  const [divRef, setDivRef] = useState("hidden");
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [operacion, setOperacion] = useState(0);
  const [cat, setCat] = useState(1);
  const [anio, setAnio] = useState([]);
  const [tecla, setTecla] = useState();
  const [tipopersona, setTipoPersona] = useState(4);
  const [status, setStatus] = useState(1);
  const [tipoRenta, setTipoRenta] = useState();
  const [factorCambio, setFactorCambio] = useState(0);
  const [deuda, setDeuda] = useState();
  const [desde1, setDesde1] = useState(0);
  const [desde2, setDesde2] = useState(0);

  const txtRitm = useRef();
  const txtDirecI = useRef();
  const txtCodCats = useRef();
  const txtTipoRenta = useRef();
  const txtTipoContri = useRef();
  const txtTipoActividad = useRef();
  const txtFechaC = useRef();
  const txtContrato = useRef();
  const txtCodCon = useRef();
  const txtCheckNatural = useRef();
  const txtCheckJuridico = useRef();
  const txtRazonS = useRef();
  const cmbCedRif = useRef();
  const txtCedRif = useRef();
  const txtTlf = useRef();
  const txtDirecI2 = useRef();
  const txtid = useRef();
  const txtActivo = useRef();
  const txtInactivo = useRef();
  const txtMontoAval = useRef();
  const txtAreaConstruccion = useRef();
  const txtAreaTerreno = useRef();
  const txtHasta = useRef();
  const txtDesde = useRef();
  const txtUsoInmueble = useRef();
  const txtUltimoAval = useRef();
  const txtTipo = useRef();
  const txtNumLoc = useRef();
  const txtDuracion = useRef();
  const txtCompra = useRef();
  const txtSimple = useRef();
  const txtMensual = useRef();
  const txtTrimestral = useRef();
  const txtAnual = useRef();
  const txtMontoPagar = useRef();
  const txtAñoDeuda = useRef();
  const txtDesdeDeuda = useRef();
  const txtHastaDeuda = useRef();

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro modificado correctamente." ||
      mensaje.texto == "registro eliminado correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
    if (mensaje.texto === "Deuda Cargada") {
      props.onHideRenderizar();
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      if (event.target.id === "montopagar") {
        if (event.which === 13) {
          btnCargar.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const blanquear = () => {
    setActivate(false);
    setDeuda();
    setDesde1(0);
    setDesde2(0);
    setTipoPersona(4);
    txtCodCon.current.value = " ";
    txtRitm.current.value = "";
    txtCodCats.current.value = " ";
    txtDirecI.current.value = " ";
    txtDirecI2.current.value = " ";
    txtTipoActividad.current.value = "";
    txtRazonS.current.value = " ";
    txtCedRif.current.value = " ";
    txtTlf.current.value = " ";
    txtTipoRenta.current.value = "";
    txtCheckNatural.current.checked = false;
    txtCheckJuridico.current.checked = false;
    txtSimple.current.checked = false;
    txtCompra.current.checked = false;
    txtAreaConstruccion.current.value = "";
    txtAreaTerreno.current.value = "";
    txtMensual.current.checked = false;
    txtTrimestral.current.checked = false;
    txtAnual.current.checked = false;
    txtDesde.current.value = "";
    txtHasta.current.value = "";
    txtUsoInmueble.current.value = "";
    txtTipo.current.value = "";
    txtNumLoc.current.value = "";
    txtDuracion.current.value = "";
    txtMontoAval.current.value = "";
    txtUltimoAval.current.value = "";
  };

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (txtTipoRenta.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar un tipo de Renta",
          icono: "informacion",
        });
        txtTipoRenta.current.focus();
        sigue = false;
      } else if (txtCodCon.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: 'Debe seleccionar un contribuyente con el Boton "BUSCAR"',
          icono: "informacion",
        });
        txtCodCon.current.focus();
        sigue = false;
      } else if (txtContrato.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Número de Contrato",
          icono: "informacion",
        });
        txtContrato.current.focus();
        sigue = false;
      } else if (txtFechaC.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Fecha del Contrato",
          icono: "informacion",
        });
        txtFechaC.current.focus();
        sigue = false;
      } else if (
        !txtCheckJuridico.current.checked &&
        !txtCheckNatural.current.checked
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar si es Prs.Natural o Prs.Juridica",
          icono: "informacion",
        });
        txtCheckJuridico.current.focus();
        sigue = false;
      } else if (cmbCedRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Letra de la Cedula o Rif",
          icono: "informacion",
        });
        cmbCedRif.current.focus();
        sigue = false;
      } else if (txtCedRif.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Número de Cedula o Rif",
          icono: "informacion",
        });
        txtCedRif.current.focus();
        sigue = false;
      } else if (txtTlf.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar un Número de Telefono Valido",
          icono: "informacion",
        });
        txtTlf.current.value = "";
        txtTlf.current.focus();
        sigue = false;
      } else if (txtRazonS.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar el Nombre o Razon Social",
          icono: "informacion",
        });
        txtRazonS.current.focus();
        sigue = false;
      } else if (txtDirecI2.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Dirección",
          icono: "informacion",
        });
        txtDirecI2.current.focus();
        sigue = false;
      } else if (txtTipoActividad.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la Actividad Principal",
          icono: "informacion",
        });
        txtTipoActividad.current.focus();
        sigue = false;
      } else if (!txtSimple.current.checked && !txtCompra.current.checked) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar un Número de Telefono Valido",
          icono: "informacion",
        });
        txtSimple.current.focus();
        sigue = false;
      } else if (
        !txtMensual.current.checked &&
        !txtTrimestral.current.checked &&
        !txtAnual.current.checked
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar un Periodo de Cancelacion",
          icono: "informacion",
        });
        txtMensual.current.focus();
        sigue = false;
      } else if (
        txtDesde.current.value === "" &&
        txtHasta.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar la fecha de inicio y culminacion",
          icono: "informacion",
        });
        txtDesde.current.focus();
        sigue = false;
      } else if (Date.parse(txtDesde) > Date.parse(txtHasta)) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La fecha de inicio no debe ser mayor a la fecha de cierre",
          icono: "informacion",
        });
        txtDesde.current.value = "";
        txtHasta.current.value = "";
        sigue = false;
      } else if (
        txtTipo.current.value === "" ||
        txtNumLoc.current.value === "" ||
        txtDuracion.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe llenar todos los Campos Correspondientes",
          icono: "informacion",
        });
        if (txtTipo.current.value === "") {
          txtTipo.current.focus();
        } else if (txtNumLoc.current.value === "") {
          txtNumLoc.current.focus();
        } else if (txtDuracion.current.value === "") {
          txtDuracion.current.focus();
        }
        sigue = false;
      } else if (sigue === true) {
        selectRenta(props.operacion);
      }
    }
  };

  const datosInmu = (idinmueble) => {
    let campos = "*";
    let nomtab = "inmueble";
    let nomid = "idinmueble";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtCodCats.current.value =
              response.data.codigocatastral.substring(0, 2) +
              "-" +
              response.data.codigocatastral.substring(2, 4) +
              "-" +
              response.data.codigocatastral.substring(4, 6) +
              "-" +
              response.data.codigocatastral.substring(6, 7) +
              "-" +
              response.data.codigocatastral.substring(7, 9) +
              "-" +
              response.data.codigocatastral.substring(9, 12) +
              "-" +
              response.data.codigocatastral.substring(12, 15) +
              "-" +
              response.data.codigocatastral.substring(15, 18) +
              "-" +
              response.data.codigocatastral.substring(18, 21) +
              "-" +
              response.data.codigocatastral.substring(21, 24) +
              "-" +
              response.data.codigocatastral.substring(24, 27);
            txtDirecI.current.value =
              response.data.dirinmue1 !== null
                ? response.data.dirinmue1.trim() + ": "
                : "" + response.data.descridirinmue1 !== null
                ? response.data.descridirinmue1.trim() + ", "
                : "" + response.data.dirinmue5 !== null
                ? response.data.dirinmue5.trim() + ": "
                : "" + response.data.descridirinmue2 !== null
                ? response.data.descridirinmue2.trim() + ", "
                : "" + response.data.ciudadocupante !== null
                ? response.data.ciudadocupante.trim()
                : "";
            txtAreaConstruccion.current.value = response.data.areaconstruccion;
            txtAreaTerreno.current.value = response.data.areaterreno;
            txtUsoInmueble.current.value = response.data.usoconstruccion;
            txtUltimoAval.current.value = moment.utc(
              response.data.fechaavaluo
            ).format("YYYY-MM-DD");
            let terr = parseFloat(response.data.valorterreno);
            let constr = parseFloat(response.data.valorconstruccion);
            let val = parseFloat(terr + constr);
            txtMontoAval.current.value = formatMoneda(
              val.toString().replace(".", ","),
              ",",
              ".",
              2
            );
            txtRitm.current.value = response.data.ritm;
            txtUsoInmueble.current.value = response.data.usoterreno;
          } else {
            txtCodCon.current.value = "";
            if (tecla === 13) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Inmueble no existe.",
                icono: "informacion",
              });
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onKeyUpComr = (idcomercio) => {
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtCodCats.current.value = "";
            txtDirecI.current.value = response.data.direccion;
            txtDirecI2.current.value = response.data.direccion;
            txtRazonS.current.value = response.data.nombre;
            cmbCedRif.current.value = response.data.rif.substring(0, 1);
            txtCedRif.current.value = response.data.rif.substring(
              1,
              response.data.cedulapropie.trim().length
            );
            txtTlf.current.value = response.data.telefono;
            setActivate(false);
          } else {
            txtCodCon.current.value = "";
            if (tecla === 13) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Comercio no existe.",
                icono: "error",
              });
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleAceptaInmueble = (
    id,
    ritm,
    nombR,
    cedrif,
    areaC,
    areaT,
    usoInm,
    fechAvalu,
    codicatas,
    direct,
    direct2,
    valor,
    usoI
  ) => {
    if (parseInt(cat) === 1) {
      setMostrar5(false);
      txtCodCon.current.value = id;
      txtCodCats.current.value =
        codicatas.substring(0, 2) +
        "-" +
        codicatas.substring(2, 4) +
        "-" +
        codicatas.substring(4, 6) +
        "-" +
        codicatas.substring(6, 7) +
        "-" +
        codicatas.substring(7, 9) +
        "-" +
        codicatas.substring(9, 12) +
        "-" +
        codicatas.substring(12, 15) +
        "-" +
        codicatas.substring(15, 18) +
        "-" +
        codicatas.substring(18, 21) +
        "-" +
        codicatas.substring(21, 24) +
        "-" +
        codicatas.substring(24, 27);
      txtDirecI.current.value = direct;
      txtAreaConstruccion.current.avalue = areaC;
      txtAreaTerreno.current.value = areaT;
      txtUsoInmueble.current.value = usoInm;
      txtUltimoAval.current.value = moment.utc(fechAvalu).format("YYYY-MM-DD");
      txtMontoAval.current.value = formatMoneda(
        valor.toString().replace(".", ","),
        ",",
        ".",
        2
      );
      txtRitm.current.value = ritm;
      txtUsoInmueble.current.value = usoI;
    } else {
      setMostrar5(false);
      txtCodCon.current.value = id;
      txtCodCats.current.value =
        codicatas.substring(0, 2) +
        "-" +
        codicatas.substring(2, 4) +
        "-" +
        codicatas.substring(4, 6) +
        "-" +
        codicatas.substring(6, 7) +
        "-" +
        codicatas.substring(7, 9) +
        "-" +
        codicatas.substring(9, 12) +
        "-" +
        codicatas.substring(12, 15) +
        "-" +
        codicatas.substring(15, 18) +
        "-" +
        codicatas.substring(18, 21) +
        "-" +
        codicatas.substring(21, 24) +
        "-" +
        codicatas.substring(24, 27);
      txtDirecI.current.value = direct;
      txtDirecI2.current.value = direct2;
      txtRazonS.current.value = nombR;
      cmbCedRif.current.value = cedrif.substring(0, 1);
      txtCedRif.current.value = cedrif.substring(1, cedrif.trim().length);
      txtAreaConstruccion.current.avalue = areaC;
      txtAreaTerreno.current.value = areaT;
      txtUsoInmueble.current.value = usoInm;
      txtUltimoAval.current.value = moment.utc(fechAvalu).format("YYYY-MM-DD");
      txtMontoAval.current.value = formatMoneda(
        valor.toString().replace(".", ","),
        ",",
        ".",
        2
      );
      txtRitm.current.value = ritm;
      txtUsoInmueble.current.value = usoI;
    }
  };

  const selectRenta = (operacion) => {
  let endpoint = `${op.conexion}/api/aseo/createaseo/${operacion}`;
  let body;
  setActivate(true);
  var periodo;
  var tipoAren;

  if (txtMensual.current.checked) {
    periodo = 1;
  } else if (txtTrimestral.current.checked) {
    periodo = 2;
  } else if (txtAnual.current.checked) {
    periodo = 3;
  }
  if (txtSimple.current.checked) {
    tipoAren = 1;
  } else if (txtCompra.current.checked) {
    tipoAren = 0;
  }
  
  // Safely get montoPagar value only if the ref exists
  let montoPagarValue = 0;
  if (txtMontoPagar.current) {
    montoPagarValue = txtMontoPagar.current.value === ""
      ? 0
      : txtMontoPagar.current.value.replace(/\./g, "").replace(",", ".");
  } else if (props.inmobiliaria && props.inmobiliaria.montoarrendamiento) {
    // Fallback to props value if available
    montoPagarValue = props.inmobiliaria.montoarrendamiento;
  }
  
  body = {
    nid: parseInt(txtid.current.value),
    idinmue: parseInt(txtCodCon.current.value),
    numcontra: txtContrato.current ? txtContrato.current.value : "",
    feccontra: txtFechaC.current ? txtFechaC.current.value : "",
    idTipren:
      txtTipoRenta.current.value === "" ? null : txtTipoRenta.current.value,
    tipper: txtCheckNatural.current.checked
      ? 0
      : txtCheckJuridico.current.checked
      ? 1
      : null,
    nomarren: txtRazonS.current.value === "" ? null : txtRazonS.current.value,
    dire: txtDirecI2.current.value === "" ? null : txtDirecI2.current.value,
    ced:
      txtCedRif.current.value === ""
        ? null
        : cmbCedRif.current.value + txtCedRif.current.value,
    tlf: txtTlf.current.value === "" ? null : txtTlf.current.value,
    fecini: txtDesde.current.value === "" ? null : txtDesde.current.value,
    fecfin: txtHasta.current.value === "" ? null : txtHasta.current.value,
    monarren: montoPagarValue,
    tiparren: tipoAren,
    pericance: periodo,
    duracont:
      txtDuracion.current.value === "" ? null : txtDuracion.current.value,
    tiploc: tipoRenta,
    numloc: txtNumLoc.current.value === "" ? null : txtNumLoc.current.value,
    tipacti:
      txtTipoActividad.current.value == ""
        ? null
        : txtTipoActividad.current.value,
    codimpu: parseInt(
      JSON.stringify(
        props.rentas[txtTipoRenta.current.selectedIndex].codigoimpuesto
      )
    ),
    nritm: txtRitm.current.value === "" ? null : txtRitm.current.value,
    tiptab: cat,
    clasif: null,
    sta: status,
    moti: null,
  };
  
  axios
    .post(endpoint, body, {
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      if (response.status == 200) {
        props.onHideRenderizar();
        if (props.operacion === 1) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro creado correctamente.",
            icono: "exito",
          });
        } else if (props.operacion === 2) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro modificado correctamente.",
            icono: "exito",
          });
        } else if (props.operacion === 3) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "registro eliminado correctamente.",
            icono: "exito",
          });
        }
      }
      setActivate(false);
    })
    .catch(function (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: error.response.data.message,
        icono: "error",
      });
      setActivate(false);
    });
};

  const verificar = () => {
    txtCodCon.current.value = " ";
    txtRitm.current.value = "";
    txtCodCats.current.value = " ";
    txtDirecI.current.value = " ";
    txtDirecI2.current.value = " ";
    txtRazonS.current.value = " ";
    txtCedRif.current.value = " ";
    txtTlf.current.value = " ";
    txtCheckNatural.current.checked = false;
    txtCheckJuridico.current.checked = false;
    txtSimple.current.checked = false;
    txtCompra.current.checked = false;
    txtAreaConstruccion.current.value = "";
    txtAreaTerreno.current.value = "";
    txtMensual.current.checked = false;
    txtTrimestral.current.checked = false;
    txtAnual.current.checked = false;
    txtDesde.current.value = "";
    txtHasta.current.value = "";
    txtUsoInmueble.current.value = "";
    txtTipo.current.value = "";
    txtNumLoc.current.value = "";
    txtDuracion.current.value = "";
    txtMontoAval.current.value = "";
    txtUltimoAval.current.value = "";
    setMostrar5(true);
  };
  const onChange = (event) => {
    if (
      event.target.name === "razonS" ||
      event.target.name === "directInm" ||
      event.target.name === "actP" ||
      event.target.name === "ritm" ||
      event.target.name === "codCon" ||
      event.target.name === "codCats" ||
      event.target.name === "directInm" ||
      event.target.name === "directInm2" ||
      event.target.name === "actividadP"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
    if (event.target.name === "inputTipo") {
      console.log(event.target.value);
      setTipoRenta(event.target.value);
    }
    if (event.target.name === "anioDeuda") {
    }
    if (event.target.name === "selectDesde") {
    }
    if (event.target.name === "selectHasta") {
    }
    if (event.target.name === "inputDesde") {
    }
    if (event.target.name === "inputHasta") {
    }
  };

  const validarContribuyente = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        if (cat === 1) {
          datosInmu(event.target.value);
        } else {
          onKeyUpComr(event.target.value);
        }
      }
    } else {
      txtCodCats.current.value = "";
      txtDirecI.current.value = "";
      txtDirecI2.current.value = "";
      txtRazonS.current.value = "";
      txtCedRif.current.value = "";
      txtAreaConstruccion.current.value = "";
      txtAreaTerreno.current.value = "";
      txtUsoInmueble.current.value = "";
      txtUltimoAval.current.value = "";
      txtMontoAval.current.value = "";
      txtRitm.current.value = "";
      txtDesde.current.value = "";
      txtHasta.current.value = "";
      txtTipo.current.value = "";
      txtNumLoc.current.value = "";
      txtDuracion.current.value = "";
      txtSimple.current.checked = false;
      txtCompra.current.checked = false;
      txtMensual.current.checked = false;
      txtTrimestral.current.checked = false;
      txtAnual.current.checked = false;
      txtTlf.current.value = "";
      txtTipoActividad.current.value = "";
    }
  };

  const validarParaCargarDeuda = (event) => {
    event.preventDefault();
    var sigue = true;
    if (operacion === 2) {
      if (txtAñoDeuda.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el Año para cargar la Deuda",
          icono: "informacion",
        });
        txtAñoDeuda.current.focus();
        sigue = false;
      } else if (
        txtDesdeDeuda.current.value === "" ||
        txtHastaDeuda.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el periodo de inicio y final",
          icono: "informacion",
        });
        txtDesdeDeuda.current.focus();
        sigue = false;
      } else if (
        parseInt(txtDesdeDeuda.current.value) >
        parseInt(txtHastaDeuda.current.value)
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "La Fecha de inicio no puede ser mayor a la fecha final",
          icono: "informacion",
        });
        txtDesdeDeuda.current.value = "";
        txtHastaDeuda.current.value = "";
        txtDesdeDeuda.current.focus();
        sigue = false;
      } else if (txtMontoPagar.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un monto para la deuda",
          icono: "informacion",
        });
        txtMontoPagar.current.focus();
        sigue = false;
      } else if (sigue) {
        selectCargarDeuda();
      }
    }
  };

  const selectCargarDeuda = () => {
    let endpoint = "";
    let body;
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/creardeudarenta`;
      body = {
        operacion: 1,
        id: parseInt(
          props.inmobiliaria
            ? props.inmobiliaria.idrentas !== null
              ? props.inmobiliaria.idrentas.trim()
              : ""
            : ""
        ),
        nomtab: "deudarentas",
        nomid: "idrentas",
        peri: props.periodoPagoR,
        monto: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
          4
        ),
        nanio: parseInt(txtAñoDeuda.current.value),
        mesdesde: parseInt(txtDesdeDeuda.current.value),
        meshasta: parseInt(txtHastaDeuda.current.value),
        nomiddeu: "iddeudarentas",
        tipo: 0,
      };
    } else {
      endpoint = `${op.conexion}/api/aseo/creardeudarenta1`;
      body = {
        operacion: 1,
        id: parseInt(
          props.inmobiliaria
            ? props.inmobiliaria.idrentas !== null
              ? props.inmobiliaria.idrentas.trim()
              : ""
            : ""
        ),
        nomtab: "deudarentas",
        monto: parseFloat(
          txtMontoPagar.current.value.replace(/\./g, "").replace(",", "."),
          4
        ),
        nanio: parseInt(txtAñoDeuda.current.value),
        mesdesde: parseInt(txtDesdeDeuda.current.value),
        meshasta: parseInt(txtHastaDeuda.current.value),
        peri: props.periodoPagoR,
      };
    }
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setActivate(false);
          setDesde1(1);
          SelectDeudaC(txtid.current.value);
          setMensaje({
            mostrar: true,
            titulo: "Notificacion",
            texto: "Deuda Cargada",
            icono: "error",
          });
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputNumChange = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.id === "inputTlf") {
        txtTlf.current.value.toString().trim().padStart(2, 0);
        if (event.which === 13) {
          txtTlf.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleChangeTipoPersona = (event) => {
    if (event.target.value === "0") {
      setTipoPersona(0);
      txtCheckNatural.current.checked = true;
      txtCheckJuridico.current.checked = false;
    } else {
      setTipoPersona(1);
      txtCheckNatural.current.checked = false;
      txtCheckJuridico.current.checked = true;
    }
  };

  const salir = () => {
    props.onHideCancela();
    blanquear();
  };

  useEffect(() => {
    let anioact = JSON.parse(localStorage.getItem("efiscalanio"));
    var nanio = [];
    var aini = parseInt(anioact) - 7;
    var afin = parseInt(anioact);

    for (let i = 0; i + aini <= afin; i++) {
      nanio.push({ anio: afin - i });
    }
    setAnio(nanio);
  }, []);

  useEffect(() => {
    if (
      props.operacion !== 1 &&
      props.inmobiliaria &&
      props.inmobiliaria.tipopersona <= 1
    ) {
      let letra = "";
      let pos = 0;
      let tipo = 4;
      if (desde2 === 0) {
        tipo = props.inmobiliaria.tipopersona;
        if (tipo === 0) {
          txtCheckNatural.current.checked = true;
          txtCheckJuridico.current.checked = false;
        } else {
          txtCheckNatural.current.checked = false;
          txtCheckJuridico.current.checked = true;
        }
        if (
          props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) > 64 &&
          props.inmobiliaria.cedrif.toUpperCase().charCodeAt(0) < 91
        ) {
          letra = props.inmobiliaria.cedrif.substring(0, 1);
          pos = 1;
        } else {
          if (tipo === 0) {
            letra = "V";
          } else {
            letra = "J";
          }
          pos = 0;
        }
        cmbCedRif.current.value = letra;
        txtCedRif.current.value = props.inmobiliaria.cedrif.substring(
          pos,
          props.inmobiliaria.cedrif.trim().length
        );
      } else {
        tipo = tipopersona;
        cmbCedRif.current.value = "";
      }
      setDesde2(1);
    }
  }, [tipopersona]);

  const mostrare = (event) => {
    const selectedIndex = txtTipoRenta.current.selectedIndex;
    if (
      parseInt(JSON.stringify(props.rentas[selectedIndex].codigoimpuesto)) === 2
    ) {
      setDivRef("visible");
    } else {
      setDivRef("hidden");
    }
  };

  const tipoContri = (e) => {
    setCat(parseInt(e.target.value));
    console.log(e.target.value);
    txtCodCon.current.value = "";
    txtCodCats.current.value = "";
    txtDirecI.current.value = "";
    txtDirecI2.current.value = "";
    txtRazonS.current.value = "";
    txtCedRif.current.value = "";
    txtAreaConstruccion.current.value = "";
    txtAreaTerreno.current.value = "";
    txtUsoInmueble.current.value = "";
    txtUltimoAval.current.value = "";
    txtMontoAval.current.value = "";
    txtRitm.current.value = "";
    txtDesde.current.value = "";
    txtHasta.current.value = "";
    txtTipo.current.value = "";
    txtNumLoc.current.value = "";
    txtDuracion.current.value = "";
    txtSimple.current.checked = false;
    txtCompra.current.checked = false;
    txtMensual.current.checked = false;
    txtTrimestral.current.checked = false;
    txtAnual.current.checked = false;
    txtTlf.current.value = "";
  };

  const SelectDeudaC = (idrentas) => {
    let tabla = "aseo";
    let endpoint = "";
    if (espiritu === 0) {
      endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    } else {
      endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${idrentas}&fecha=${fechaSistema}&tabla=${tabla} `;
    }
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu * factorCambio,
                intereses: response.data[i].intmoradeu * factorCambio,
                multa: response.data[i].multa * factorCambio,
                recargo: response.data[i].recargodeu * factorCambio,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
              });
            }
          }
          setDeuda(deu);
          setActivate(false);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setFactorCambio(props.factorCambio);
        setOperacion(props.operacion);
        setCat(1);
        setDesde1(0);
        if (props.operacion === 1) {
          setDivRef("hidden");
          txtCheckNatural.current.checked = true;
          txtCheckJuridico.current.checked = false;
          txtFechaC.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
        } else {
          setDesde2(0);
          setTipoPersona(props.inmobiliaria.tipopersona);
          if (
            props.inmobiliaria &&
            props.inmobiliaria.codigoimpuesto &&
            props.inmobiliaria.codigoimpuesto.toString() === "2"
          ) {
            setDivRef("visible");
          } else {
            setDivRef("hidden");
          }
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-beetwen azulGradiant">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Registrar Contribuyente Rentas Inmobiliarias."
            : operacion === 2
            ? "Editar Contribuyente Rentas Inmobiliarias."
            : operacion === 3
            ? "Eliminar Contribuyente Rentas Inmobiliarias."
            : "Consultar Contribuyente Rentas Inmobiliarias."}
        </h3>
        <a type = 'button'
          ref={btnCancela}
          className="fw-bold fs-6 text-light"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i> 
        </a>
      </Modal.Header>
      <Modal.Body>
        <ul className="nav mb-2" id="ex-with-icons" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className="rounded nav-link active bg-blue-100 text-light"
              id="datosTributarios"
              data-bs-toggle="tab"
              data-bs-target="#tributarios"
              type="button"
              role="tab"
              aria-controls="tributarios"
              aria-selected="true"
            >
              Datos Generales
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              rounded
              className="nav-link bg-blue-200 text-light"
              disabled={operacion === 1 || operacion === 3 ? true : false}
              id="deuda-tab"
              data-bs-toggle="tab"
              data-bs-target="#deuda"
              type="button"
              role="tab"
              aria-controls="deuda"
              aria-selected="false"
            >
              Deudas del Contribuyente
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className="rounded nav-link bg-blue-300 text-light"
              disabled={operacion === 1 || operacion === 3 ? true : false}
              id="hist-tab"
              data-bs-toggle="tab"
              data-bs-target="#historico"
              type="button"
              role="tab"
              aria-controls="historico"
              aria-selected="false"
            >
              Historicos de Pagos
            </a>
          </li>
          <div className="input-group mr-0 input-group-sm mb-1 col-md-2">
            <span className="input-group-text bg-transparent fw-bold border-0">
              Valor Euro €:
            </span>
            <span className="input-group-text bg-transparent fw-bold border-0">
              {formatMoneda(
                factorCambio.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2
              )}
            </span>
          </div>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="tributarios"
            role="tabpanel"
            aria-labelledby="datosTributarios"
          >
            <div className="col-12 m-0 p-0 d-flex flex-wrap">
              <div className="col-2 m-0 mb-2 p-0">
                <Input label = 'Código:'
                  ref={txtid}
                  disabled
                  defaultValue={
                    props.inmobiliaria
                      ? props.inmobiliaria.idrentas !== null
                        ? props.inmobiliaria.idrentas.trim()
                        : ""
                      : ""
                  }
                  id="inputCodigo"
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Select label = 'Tipo de Renta:'
                  name="idclasevehiculo"
                  ref={txtTipoRenta}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  value={props.inmobiliaria && props.inmobiliaria.idtiporenta}
                  onChange={mostrare}
                  id="inputTP"
                >
                  {props.rentas &&
                    props.rentas.map((item, index) => (
                      <option
                        key={item.codigoimpuesto}
                        value={item.idtiporentas}
                      >
                        {item.descripcion}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="col-4 m-0 mb-2 ml-auto p-0" style={{ visibility: divRef }}>
                <Select label = 'Tipo de Contribuyente:'
                  name="idclasevehiculo"
                  ref={txtTipoContri}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  defaultValue={
                    props.inmobiliaria && props.inmobiliaria.tipotabla
                  }
                  onChange={tipoContri}
                  id="inputTP"
                >
                  <option value="1">Inmueble</option>
                  <option value="0">Comercio</option>
                </Select>
              </div>
              <div className="col-2 m-0 mb-2 p-0 pl-2">
                <Input label = 'RITM:'
                  ref={txtRitm}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  defaultValue={
                    props.inmobiliaria
                      ? props.inmobiliaria.ritm !== null
                        ? props.inmobiliaria.ritm.trim()
                        : ""
                      : ""
                  }
                  id="ritm"
                  name="ritm"
                  onChange={onChange}
                />
              </div>
              <div className="col-2 m-0 mb-2 p-0">
                <SearchInput label = 'Cod. Comtrib:'
                  ref={txtCodCon}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  defaultValue={
                    props.inmobiliaria
                      ? props.inmobiliaria.idinmueble !== null
                        ? props.inmobiliaria.idinmueble.trim()
                        : ""
                      : ""
                  }
                  id="codCon"
                  name="codCon"
                  onChange={onChange}
                  onKeyUp={validarContribuyente}
                  onBlur={validarContribuyente}
                  onClickButton = {verificar}
                  disabledButton = {operacion === 1 || operacion === 2 ? false : true}
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'N° Contrato'
                  ref={txtContrato}
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  id="codCats"
                  name="codCats"
                  defaultValue={
                    props.inmobiliaria &&
                    props.inmobiliaria.numcontrato !== ""
                      ? props.inmobiliaria.numcontrato
                      : " "
                  }
                />
              </div>
              <div className="col-3 m-0 mb-2 p-0 pl-2">
                <Input label = 'Fecha Contrato'
                  type="date"
                  disabled={operacion === 1 || operacion === 2 ? false : true}
                  ref={txtFechaC}
                  id="codCats"
                  name="codCats"
                  defaultValue={
                    props.inmobiliaria &&
                    props.inmobiliaria.fechacontrato !== ""
                      ? moment.utc(props.inmobiliaria.fechacontrato).format(
                          "YYYY-MM-DD"
                        )
                      : " "
                  }
                />
              </div>
              <div className="col-4 m-0 mb-2 p-0 pl-2">
                <Input label = 'Código Catastral:'
                  disabled
                  ref={txtCodCats}
                  defaultValue={
                    props.inmueble
                      ? props.inmueble.codigocatastral !== null
                        ? props.inmueble.codigocatastral
                            .trim()
                            .substring(0, 2) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(2, 4) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(4, 6) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(6, 7) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(7, 9) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(9, 12) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(12, 15) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(15, 18) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(18, 21) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(21, 24) +
                          "-" +
                          props.inmueble.codigocatastral
                            .trim()
                            .substring(24, 27)
                        : ""
                      : ""
                  }
                  id="codCats"
                  name="codCats"
                  onChange={onChange}
                />
              </div>
              <div className="col-6 m-0 mb-2 p-0">
                <Input label = 'Dirección del Inmueble:'
                  disabled
                  ref={txtDirecI}
                  defaultValue={
                    props.inmobiliaria
                      ? props.inmobiliaria.direccion !== null
                        ? props.inmobiliaria.direccion.trim()
                        : ""
                      : ""
                  }
                  id="directInm"
                  name="directInm"
                  onChange={onChange}
                />
              </div>
              {operacion !== 1 &&
                <div className="col-6 m-0 p-0 d-flex gap-2">
                  <span className="fw-bold">
                    Status
                  </span>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Activo'
                      ref={txtActivo}
                      disabled={operacion === 2 ? false : true}
                      name="checkStatus"
                      value={0}
                      defaultChecked={
                        props.inmobiliaria && props.inmobiliaria.status === 0
                      }
                      id="checkStatus"
                      onChange={(event) => setStatus(event.target.value)}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Inactivo'
                      ref={txtInactivo}
                      disabled={operacion === 2 ? false : true}
                      name="checkStatus"
                      value={1}
                      defaultChecked={
                        props.inmobiliaria && props.inmobiliaria.status === 1
                      }
                      id="checkStatus"
                      onChange={(event) => setStatus(event.target.value)}
                    />
                  </div>
                </div>
              }
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto m-0">
                  Datos del Arrendatario
                </legend>
                <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">
                    Tipos de Contribuyentes:
                  </span>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Prs. Natural'
                      ref={txtCheckNatural}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      name="radioPers"
                      value={"0"}
                      id="radioPers"
                      onChange={handleChangeTipoPersona}
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Prs. Jurídica'
                      ref={txtCheckJuridico}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      name="radioPers"
                      value={"1"}
                      id="radioPers2"
                      onChange={handleChangeTipoPersona}
                    />
                  </div>
                </div>
                <div className="col-4 m-0 mb-2 p-0 d-flex">
                  <div className="col-4 m-0 p-0">
                    {tipopersona === 0 ? (
                      <Select label  = 'Cedula/Rif:'
                        ref={cmbCedRif}
                        id="inputCedRif"
                        defaultValue={
                          props.inmobiliaria
                            ? props.inmobiliaria.cedrif !== null
                              ? props.inmobiliaria.cedrif
                                  .trim()
                                  .toUpperCase()
                                  .charCodeAt(0) > 64 &&
                                props.inmobiliaria.cedrif
                                  .trim()
                                  .toUpperCase()
                                  .charCodeAt(0) < 91
                                ? props.inmobiliaria.cedrif
                                    .trim()
                                    .substring(0, 1)
                                : ""
                              : ""
                            : ""
                        }
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                      >
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </Select>
                    ) : (
                      <Select label = 'Cedula/Rif:'
                        ref={cmbCedRif}
                        id="inputCedRif"
                        defaultValue={
                          props.inmobiliaria
                            ? props.inmobiliaria.cedrif !== null
                              ? props.inmobiliaria.cedrif
                                  .trim()
                                  .toUpperCase()
                                  .charCodeAt(0) > 64 &&
                                props.inmobiliaria.cedrif
                                  .trim()
                                  .toUpperCase()
                                  .charCodeAt(0) < 91
                                ? props.inmobiliaria.cedrif
                                    .trim()
                                    .substring(0, 1)
                                : ""
                              : ""
                            : ""
                        }
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                      >
                        <option value="J">J</option>
                        <option value="V">V</option>
                        <option value="G">G</option>
                      </Select>
                    )}
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Input 
                      ref={txtCedRif}
                      disabled={
                        operacion === 1 || operacion === 2 ? false : true
                      }
                      defaultValue={
                        props.inmobiliaria
                          ? props.inmobiliaria.cedrif !== null
                            ? props.inmobiliaria.cedrif.trim()
                            : ""
                          : ""
                      }
                      id="inputCodigo"
                    />
                  </div>
                </div>
                <div className="col-3 m-0 mb-2 ml-auto p-0">
                  <Input label = 'Telefono:'
                    ref={txtTlf}
                    minLength={11}
                    maxLength={11}
                    disabled={
                      operacion === 1 || operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.telefono !== null
                          ? props.inmobiliaria.telefono.trim()
                          : ""
                        : ""
                    }
                    id="inputTlf"
                    name="inputTlf"
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Input label = 'Nombre o Razon Social:'
                    ref={txtRazonS}
                    disabled={
                      operacion === 1 || operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.nombrearrendatario !== null
                          ? props.inmobiliaria.nombrearrendatario.trim()
                          : ""
                        : ""
                    }
                    id="razonS"
                    name="razonS"
                    onChange={onChange}
                  />
                </div>
                <div className="col-12 m-0 mb-2 p-0">
                  <Textarea label = 'Dirección:'
                    style={{ height: 70 }}
                    ref={txtDirecI2}
                    disabled={
                      operacion === 1 || operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.direccion !== null
                          ? props.inmobiliaria.direccion.trim()
                          : ""
                        : ""
                    }
                    id="directInm2"
                    name="directInm2"
                    onChange={onChange}
                  />
                </div>
                <div className="col-12 m-0 p-0">
                  <Textarea label = 'Tipo de Actividad:'
                    style={{ height: 70 }}
                    ref={txtTipoActividad}
                    disabled={
                      operacion === 1 || operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.tipoactividad !== null
                          ? props.inmobiliaria.tipoactividad.trim()
                          : ""
                        : ""
                    }
                    id="actividadP"
                    name="actividadP"
                    onChange={onChange}
                  />
                </div>
              </fieldset>
              <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                <legend className="float-none w-auto fw-bold m-0">
                  Información Inmueble
                </legend>
                <div className="col-6 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">
                    Tipo Arrendamiento:
                  </span>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Simple'
                      disabled={
                        operacion === 1
                          ? false
                          : operacion === 2
                          ? false
                          : true
                      }
                      ref={txtSimple}
                      name="TA"
                      value="1"
                      defaultChecked={
                        props.inmobiliaria &&
                        props.inmobiliaria.tipoarrendamiento === 1
                      }
                      id="TA"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Opcion a Compra'
                      disabled={
                        operacion === 1
                          ? false
                          : operacion === 2
                          ? false
                          : true
                      }
                      ref={txtCompra}
                      name="TA"
                      value="0"
                      defaultChecked={
                        props.inmobiliaria &&
                        props.inmobiliaria.tipoarrendamiento === 0
                      }
                      id="TA2"
                    />
                  </div>
                </div>
                <div className="col-6 m-0 mb-2 p-0 d-flex gap-2">
                  <span className="fw-bold">
                    Periodo Cancelacion
                  </span>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Mens.'
                      disabled={
                        operacion === 1
                          ? false
                          : operacion === 2
                          ? false
                          : true
                      }
                      ref={txtMensual}
                      name="radioDeclara"
                      value="1"
                      defaultChecked={
                        props.inmobiliaria &&
                        props.inmobiliaria.periododecancelacion === 1
                      }
                      id="radioSi1"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Trimest.'
                      disabled={
                        operacion === 1
                          ? false
                          : operacion === 2
                          ? false
                          : true
                      }
                      ref={txtTrimestral}
                      name="radioDeclara"
                      value="2"
                      defaultChecked={
                        props.inmobiliaria &&
                        props.inmobiliaria.periododecancelacion === 2
                      }
                      id="radioSi2"
                    />
                  </div>
                  <div className="col-auto m-0 p-0">
                    <Radio label = 'Anul'
                      disabled={
                        operacion === 1
                          ? false
                          : operacion === 2
                          ? false
                          : true
                      }
                      ref={txtAnual}
                      name="radioDeclara"
                      value="3"
                      defaultChecked={
                        props.inmobiliaria &&
                        props.inmobiliaria.periododecancelacion === 3
                      }
                      id="radioSi3"
                    />
                  </div>
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Input label = 'Area Contrucción (m²)'
                    disabled
                    ref={txtAreaConstruccion}
                    defaultValue={
                      props.inmueble
                        ? props.inmueble.areaconstruccion !== null
                          ? formatMoneda(
                              props.inmueble.areaconstruccion
                                .trim()
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                        : ""
                    }
                    id="AreaCons"
                    name="AreaCons"
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Area del Terreno(m²)'
                    disabled
                    ref={txtAreaTerreno}
                    defaultValue={
                      props.inmueble
                        ? props.inmueble.areaterreno !== null
                          ? formatMoneda(
                              props.inmueble.areaterreno
                                .trim()
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                        : ""
                    }
                    id="inputDesde"
                    name="inputDesde"
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Desde:'
                    type="date"
                    ref={txtDesde}
                    disabled={
                      operacion === 1 ? false : operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? moment.utc(props.inmobiliaria.fechainicio).format(
                            "YYYY-MM-DD"
                          ) !== null
                          ? moment.utc(props.inmobiliaria.fechainicio).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                        : ""
                    }
                    id="inputDesde"
                    name="inputDesde"
                    onChange={onChange}
                  />
                </div>
                <div className="col-2 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Hasta:'
                    type="date"
                    ref={txtHasta}
                    disabled={
                      operacion === 1 ? false : operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? moment.utc(props.inmobiliaria.fechaculminacion).format(
                            "YYYY-MM-DD"
                          ) !== null
                          ? moment.utc(
                              props.inmobiliaria.fechaculminacion
                            ).format("YYYY-MM-DD")
                          : ""
                        : ""
                    }
                    id="inputHasta"
                    name="inputHasta"
                    onChange={onChange}
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0">
                  <Input label = 'Uso de Inmueble:'
                    disabled
                    ref={txtUsoInmueble}
                    defaultValue={
                      props.inmueble
                        ? props.inmueble.usoterreno !== null
                          ? props.inmueble.usoterreno.trim()
                          : ""
                        : ""
                    }
                    id="inputDesde"
                    name="inputDesde"
                  />
                </div>
                <div className="col-3 m-0 mb-2 p-0 pl-2">
                  <Input label = 'Fch. Ult. Avaluo:'
                    type="date"
                    disabled
                    ref={txtUltimoAval}
                    defaultValue={
                      props.inmobiliaria
                        ? moment.utc(props.inmobiliaria.fechaavaluo).format(
                            "YYYY-MM-DD"
                          ) !== null
                          ? moment.utc(props.inmobiliaria.fechaavaluo).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                        : ""
                    }
                    id="inputDesde"
                    name="inputDesde"
                  />
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Select label = "Tipo:"
                    name="inputTipo"
                    ref={txtTipo}
                    disabled={
                      operacion === 1 ? false : operacion === 2 ? false : true
                    }
                    onChange={onChange}
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.tipoloc !== null
                          ? props.inmobiliaria.tipoloc.trim()
                          : "hola"
                        : "hola"
                    }
                  >
                    <option key={1} value="LOCAL">
                      LOCAL
                    </option>
                    <option key={2} value="OFICINA">
                      OFICINA
                    </option>
                    <option key={3} value="PUESTO">
                      PUESTO
                    </option>
                    <option key={4} value="TERRENO">
                      TERRENO
                    </option>
                  </Select>
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Input label = 'N°:'
                    ref={txtNumLoc}
                    disabled={
                      operacion === 1 ? false : operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.numeroloc !== null
                          ? props.inmobiliaria.numeroloc.trim()
                          : ""
                        : ""
                    }
                    id="inputNum"
                    name="inputNum"
                  />
                </div>
                <div className="col-2 m-0 p-0 pl-2">
                  <Input label = 'Duración:'
                    ref={txtDuracion}
                    disabled={
                      operacion === 1 ? false : operacion === 2 ? false : true
                    }
                    defaultValue={
                      props.inmobiliaria
                        ? props.inmobiliaria.duraciondelcontrato !== null
                          ? props.inmobiliaria.duraciondelcontrato.trim()
                          : ""
                        : ""
                    }
                    id="inputDesde"
                    name="inputDesde"
                  />
                </div>
                <div className="col-3 m-0 p-0">
                  <Input label = 'Monto Total Avalúo'
                    disabled
                    ref={txtMontoAval}
                    defaultValue={
                      props.inmueble
                        ? props.inmueble.valorterreno &&
                          props.inmueble.valorconstruccion !== null
                          ? formatMoneda(
                              (
                                parseFloat(props.inmueble.valorconstruccion) +
                                parseFloat(props.inmueble.valorterreno)
                              )
                                .toString()
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : " "
                        : " "
                    }
                    id="inputAvaluo"
                    name="inputAvaluo"
                    onChange={onChange}
                  />
                </div>

                {operacion == 1 &&
                  <div className="col-12 m-0 mt-2 p-0 d-flex align-items-center">
                    <div className="col-2 m-0 p-0">
                      <Select label = 'Año:'
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        ref={txtAñoDeuda}
                        name="anioDeuda"
                        onChange={onChange}
                      >
                        {anio &&
                          anio.map((a) => (
                            <option key={a.anio} value={a.anio}>
                              {a.anio}
                            </option>
                          ))}
                      </Select>
                    </div>
                    <div className="col-6 m-0 p-0 pl-2 d-flex gap-2 align-items-center">
                      <span className="fw-bold">
                        Periodos de Deuda:
                      </span>
                      <div className="col m-0 p-0">
                        <Select label = 'Desde:'
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={txtDesdeDeuda}
                          name="selectDesde"
                          onChange={onChange}
                        >
                          <option key="1" value="1">
                            ENERO
                          </option>
                          <option key="2" value="2">
                            FEBRERO
                          </option>
                          <option key="3" value="3">
                            MARZO
                          </option>
                          <option key="4" value="4">
                            ABRIL
                          </option>
                          <option key="5" value="5">
                            MAYO
                          </option>
                          <option key="6" value="6">
                            JUNIO
                          </option>
                          <option key="7" value="7">
                            JULIO
                          </option>
                          <option key="8" value="8">
                            AGOSTO
                          </option>
                          <option key="9" value="9">
                            SEPTIEMBRE
                          </option>
                          <option key="10" value="10">
                            OCTUBRE
                          </option>
                          <option key="11" value="11">
                            NOVIEMBRE
                          </option>
                          <option key="12" value="12">
                            DICIEMBRE
                          </option>
                        </Select>
                      </div>
                      <div className="col m-0 p-0">
                        <Select label = 'Hasta:'
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={txtHastaDeuda}
                          name="selectHasta"
                          onChange={onChange}
                          defaultValue={"12"}
                        >
                          <option key="1" value="1">
                            ENERO
                          </option>
                          <option key="2" value="2">
                            FEBRERO
                          </option>
                          <option key="3" value="3">
                            MARZO
                          </option>
                          <option key="4" value="4">
                            ABRIL
                          </option>
                          <option key="5" value="5">
                            MAYO
                          </option>
                          <option key="6" value="6">
                            JUNIO
                          </option>
                          <option key="7" value="7">
                            JULIO
                          </option>
                          <option key="8" value="8">
                            AGOSTO
                          </option>
                          <option key="9" value="9">
                            SEPTIEMBRE
                          </option>
                          <option key="10" value="10">
                            OCTUBRE
                          </option>
                          <option key="11" value="11">
                            NOVIEMBRE
                          </option>
                          <option key="12" value="12">
                            DICIEMBRE
                          </option>
                        </Select>
                      </div>
                    </div>

                    <div className="col-4 m-0 p-0 pl-2 d-flex input-group-sm">
                      <Input label = 'Monto a Pagar:'
                        disabled={
                          operacion === 1 || operacion === 2 ? false : true
                        }
                        ref={txtMontoPagar}
                        defaultValue={
                          props.inmobiliaria &&
                          props.inmobiliaria.montoarrendamiento
                            ? formatMoneda(
                                props.inmobiliaria.montoarrendamiento
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            : "0,00"
                        }
                        id="montoPagar"
                        name="montoPagar"
                        onKeyUp={handleInputMontoChange}
                        onBlur={handleInputMontoChange}
                      />
                      <div className="col-auto m-0 p-0">
                        <InfoButton icon = 'm-0'
                          className = 'rounded-0 m-0'
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          ref={btnCargar}
                          onClick={validarParaCargarDeuda}
                        >
                          Cargar
                        </InfoButton>
                      </div>
                    </div>
                  </div>
                }
              </fieldset>
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="deuda"
            role="tabpanel"
            aria-labelledby="deuda-tab"
          >
            <div className="row col-md-12">
              <TablaDeudasEjidos
                tabdeuda={desde1 === 0 ? props.deuda : deuda}
                idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
                visibleF={"hidden"}
                credito={
                  props.credito && props.credito > 0 ? props.credito : 0.0
                }
              />
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="historico"
            role="tabpanel"
            aria-labelledby="hist-tab"
          >
            <div className="row col-md-12 mx-auto">
              <TablaHistoricosEjidos
                tabHis={props.historico}
                idrentas={props.inmobiliaria && props.inmobiliaria.idrentas}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <Dimmer active={activate}></Dimmer>
      <CatalagoInmo2
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        cat={cat}
        onHideAceptaCatInm={handleAceptaInmueble}
      />
    </Modal>
  );
};
